import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.isTouch = window.matchMedia("(hover: none)").matches
    if (this.isTouch) {
      this._outsideClick = this.deactivate.bind(this)
      document.addEventListener("click", this._outsideClick)
    }
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClick)
  }

  activate(event) {
    if (!this.isTouch) return
    const item = event.currentTarget
    if (item.classList.contains("is-active")) return
    event.preventDefault()
    event.stopPropagation()
    this.deactivate()
    item.classList.add("is-active")
    this.element.classList.add("has-active")
  }

  deactivate() {
    this.element.querySelectorAll(".is-active").forEach(el => el.classList.remove("is-active"))
    this.element.classList.remove("has-active")
  }
}
